import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isAdmin = user?.user_type === 'admin';

  const isActiveRoute = (path: string) => location.pathname === path;

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img 
              src="https://lmplumbersworcester.co.uk/wp-content/uploads/2025/07/Transparent-PNG-01-scaled.png" 
              alt="LM Plumbing" 
              style={{ height: '40px', width: 'auto' }}
            />
          </Link>
        </div>
        
        <nav style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <Link
            to="/"
            style={{
              color: isActiveRoute('/') ? '#2c3e50' : '#666',
              textDecoration: 'none',
              fontWeight: isActiveRoute('/') ? 'bold' : 'normal',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              backgroundColor: isActiveRoute('/') ? 'rgba(44, 62, 80, 0.1)' : 'transparent'
            }}
          >
            Tasks
          </Link>
          <Link
            to="/calendar"
            className="calendar-nav-link"
            style={{
              color: isActiveRoute('/calendar') ? '#2c3e50' : '#666',
              textDecoration: 'none',
              fontWeight: isActiveRoute('/calendar') ? 'bold' : 'normal',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              backgroundColor: isActiveRoute('/calendar') ? 'rgba(44, 62, 80, 0.1)' : 'transparent'
            }}
          >
            Calendar
          </Link>
          <Link
            to="/archived"
            style={{
              color: isActiveRoute('/archived') ? '#2c3e50' : '#666',
              textDecoration: 'none',
              fontWeight: isActiveRoute('/archived') ? 'bold' : 'normal',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              backgroundColor: isActiveRoute('/archived') ? 'rgba(44, 62, 80, 0.1)' : 'transparent'
            }}
          >
            Archived
          </Link>
          {isAdmin && (
            <>
              <Link 
                to="/users" 
                style={{ 
                  color: isActiveRoute('/users') ? '#2c3e50' : '#666',
                  textDecoration: 'none',
                  fontWeight: isActiveRoute('/users') ? 'bold' : 'normal',
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  backgroundColor: isActiveRoute('/users') ? 'rgba(44, 62, 80, 0.1)' : 'transparent'
                }}
              >
                Users
              </Link>
              <Link 
                to="/clients" 
                style={{ 
                  color: isActiveRoute('/clients') ? '#2c3e50' : '#666',
                  textDecoration: 'none',
                  fontWeight: isActiveRoute('/clients') ? 'bold' : 'normal',
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  backgroundColor: isActiveRoute('/clients') ? 'rgba(44, 62, 80, 0.1)' : 'transparent'
                }}
              >
                Clients
              </Link>
            </>
          )}
        </nav>

        <div className="user-info">
          <span>Welcome, {user?.first_name} {user?.last_name}</span>
          <span className="user-badge">{user?.user_type}</span>
          <button onClick={logout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;